import { render, staticRenderFns } from "./RelatedTransactionsViewer.vue?vue&type=template&id=436ceadb&scoped=true&"
import script from "./RelatedTransactionsViewer.vue?vue&type=script&lang=js&"
export * from "./RelatedTransactionsViewer.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTransactionsViewer.vue?vue&type=style&index=0&id=436ceadb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ceadb",
  null
  
)

export default component.exports